// 🧹 Test tozalash — test serverdagi sinov ma'lumotlarini o'chirish (Khorezmai, 2026-10-02).
// Faqat test hostda ko'rinadi (isTestEnv) — prod (app.tezhal.uz) da menyuda ham, sahifada ham yo'q.
// Backend ham alohida tekshiradi: admin + test host + «TOZALASH» tasdig'i (routes/admin/testCleanup.js).
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from '../components/AdminLayout';
import { apiFetch } from '../api';
import { PageHeader, Loading, ErrorBanner, ui } from '../components/adminUi';
import { isTestEnv } from '../lib/testEnv';

export default function TestCleanupPage() {
  const { auth } = useAuth();
  const [phone, setPhone] = useState('');
  const [appliedPhone, setAppliedPhone] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const [result, setResult] = useState('');

  const load = useCallback(async (ph) => {
    setLoading(true); setError('');
    try {
      const q = ph ? `?phone=${encodeURIComponent(ph)}` : '';
      const res = await apiFetch(`/api/admin/test-cleanup${q}`, auth.token);
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { setError(d.message || 'Yuklab bo\'lmadi'); setData(null); return; }
      setData(d); setAppliedPhone(ph || '');
    } catch {
      setError('Tarmoq xatosi. Qayta urinib ko\'ring.');
    } finally { setLoading(false); }
  }, [auth.token]);

  useEffect(() => { if (isTestEnv()) load(''); }, [load]);

  const scopeText = appliedPhone ? ` (faqat ${appliedPhone} raqami)` : ' (HAMMA foydalanuvchilar)';

  const clean = async (category, label) => {
    if (category === 'all') {
      const typed = window.prompt(`Test bazadagi BARCHA sinov ma'lumoti${scopeText} o'chiriladi. Qaytarib bo'lmaydi.\n\nDavom etish uchun TOZALASH deb yozing:`);
      if (typed !== 'TOZALASH') return;
    } else if (!window.confirm(`«${label}»${scopeText} o'chirilsinmi? Qaytarib bo'lmaydi.`)) {
      return;
    }
    setBusy(category); setError(''); setResult('');
    try {
      const res = await apiFetch('/api/admin/test-cleanup', auth.token, {
        method: 'POST',
        body: JSON.stringify({ category, confirm: 'TOZALASH', phone: appliedPhone || undefined }),
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) { setError(d.message || 'Tozalashda xatolik'); return; }
      const parts = Object.entries(d.deleted || {}).filter(([, n]) => n > 0).map(([t, n]) => `${t}: ${n}`);
      setResult(`✅ ${label} tozalandi — ${d.total || 0} ta yozuv${parts.length ? ` (${parts.join(', ')})` : ''}`);
      await load(appliedPhone);
    } catch {
      setError('Tarmoq xatosi. Qayta urinib ko\'ring.');
    } finally { setBusy(''); }
  };

  if (!isTestEnv()) {
    return (
      <AdminLayout>
        <PageHeader title="Test tozalash" />
        <ErrorBanner>Bu bo'lim faqat test serverida ishlaydi.</ErrorBanner>
      </AdminLayout>
    );
  }

  const otp = data && data.categories.find((c) => c.key === 'otp');

  return (
    <AdminLayout>
      <PageHeader title="🧹 Test tozalash" subtitle="Test serverdagi sinov ma'lumotlarini o'chirish — foydalanuvchilar, ustalar va sozlamalar saqlanadi">
        <button style={ui.addBtn} onClick={() => load(appliedPhone)} disabled={loading}>↻ Yangilash</button>
      </PageHeader>

      <div style={s.warn}>
        ⚠️ O'chirilgan ma'lumotni qaytarib bo'lmaydi. Faqat TEST serverida ishlaydi — prod (tezhal.uz) bazasiga tegmaydi.
      </div>

      <div style={s.card}>
        <label style={ui.label}>📱 Telefon bo'yicha (ixtiyoriy)</label>
        <div style={s.row}>
          <input
            style={{ ...ui.input, flex: 1, minWidth: '220px' }}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') load(phone.trim()); }}
            placeholder="901234567 yoki +998901234567 — bir nechtasini vergul bilan"
          />
          <button style={{ ...ui.btnSm, ...ui.btnBlue }} onClick={() => load(phone.trim())} disabled={loading}>🔎 Tekshirish</button>
          {appliedPhone && (
            <button style={{ ...ui.btnSm, ...ui.btnGray }} onClick={() => { setPhone(''); load(''); }}>✕ Hammasi</button>
          )}
          <button
            style={{ ...ui.btnSm, ...s.amber }}
            disabled={!!busy || !otp}
            title="Kunlik SMS chegarasi va eski kodlar — darhol qayta kod so'rash mumkin bo'ladi"
            onClick={() => clean('otp', 'SMS kodlar va limit')}
          >📱 SMS limitni tozalash</button>
        </div>
        <div style={s.scope}>
          {data && data.scope
            ? (data.scope.users.length
              ? <>🎯 Faqat: {data.scope.users.map((u) => `${u.name} (${u.role})`).join(', ')}</>
              : <>⚠️ Bu raqamli foydalanuvchi yo'q — faqat «SMS kodlar va limit» tozalanadi (ro'yxatdan o'tish sinovi uchun)</>)
            : 'Raqam kiritilmasa — HAMMA foydalanuvchilarning sinov ma\'lumoti.'}
        </div>
      </div>

      <ErrorBanner>{error}</ErrorBanner>
      {result && <div style={s.success}>{result}</div>}

      {loading && !data ? <Loading /> : data && (
        <div style={s.grid}>
          {data.categories.map((c) => (
            <div key={c.key} style={{ ...s.cat, ...(c.usable ? {} : s.catOff) }}>
              <div style={s.catHead}>
                <span style={s.catTitle}>{c.label}</span>
                <span style={s.count}>{c.usable ? c.total : '—'}</span>
              </div>
              {c.hint && <div style={s.hint}>{c.hint}</div>}
              <div style={s.tables}>
                {c.tables.map((t) => <span key={t.table} style={s.tbl}>{t.table}: {t.count}</span>)}
              </div>
              <button
                style={{ ...ui.btnSm, ...ui.btnRed, marginTop: 'auto' }}
                disabled={!!busy || !c.usable || c.total === 0}
                onClick={() => clean(c.key, c.label)}
              >{busy === c.key ? '⏳ Tozalanmoqda…' : '🗑 Tozalash'}</button>
            </div>
          ))}
        </div>
      )}

      {data && (
        <div style={{ ...s.card, marginTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: '220px', fontSize: '14px', color: 'var(--text-secondary)' }}>
            Jami: <b>{data.total}</b> ta yozuv{scopeText}
          </div>
          <button
            style={{ ...ui.btnSm, ...ui.btnRed, fontWeight: 700 }}
            disabled={!!busy || data.total === 0}
            onClick={() => clean('all', 'Hammasi')}
          >{busy === 'all' ? '⏳ Tozalanmoqda…' : '🧹 Hammasini tozalash'}</button>
        </div>
      )}
    </AdminLayout>
  );
}

const s = {
  warn: {
    background: '#fffbeb', border: '1px solid #fcd34d', color: '#b45309',
    borderRadius: '10px', padding: '12px 14px', fontSize: '14px', marginBottom: '16px',
  },
  card: {
    background: 'var(--surface)', borderRadius: '12px', padding: '18px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: '16px',
  },
  row: { display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' },
  scope: { marginTop: '10px', fontSize: '13px', color: 'var(--text-muted)' },
  amber: { background: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d' },
  success: {
    background: 'var(--success-tint)', border: '1px solid #bbf7d0', borderRadius: '8px',
    padding: '12px 14px', color: 'var(--success)', fontSize: '14px', marginBottom: '16px',
  },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '14px' },
  cat: {
    background: 'var(--surface)', borderRadius: '12px', padding: '16px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: '8px', minHeight: '150px',
  },
  catOff: { opacity: 0.5 },
  catHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '8px' },
  catTitle: { fontWeight: 700, fontSize: '15px', color: 'var(--text)' },
  count: { fontWeight: 700, fontSize: '20px', color: 'var(--brand)' },
  hint: { fontSize: '12px', color: 'var(--text-muted)' },
  tables: { display: 'flex', flexWrap: 'wrap', gap: '4px' },
  tbl: { fontSize: '11px', background: 'var(--surface-alt)', color: 'var(--text-secondary)', borderRadius: '6px', padding: '2px 6px' },
};
